import { alpha, Avatar, AvatarProps } from "@mui/material";

export interface AvatarIconButtonProps extends AvatarProps {}

export default function AvatarIconButton({
  children,
  sx,
  ...rest
}: AvatarIconButtonProps) {
  return (
    <Avatar
      onClick={() => {}}
      variant="rounded"
      sx={{
        color: "common.white",
        width: "34px",
        height: "34px",
        backgroundColor: theme => theme.palette.primary.main,
        transition: "background 0.3s, color 0.3s",
        cursor: "pointer",
        "&:hover": {
          color: "primary.light",
          backgroundColor: theme => alpha(theme.palette.primary.main, 0.5),
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Avatar>
  );
}
